import React from "react";
import { useNavigate } from "react-router-dom";
// import "../styles/sidebar.css";
import '../App.css'
import { ApiUrl } from '../Constants/Weburl'
import { NavLink } from "react-router-dom";

// export default function SettingSidebar() {
//   const navigate = useNavigate();

//   const menuItems = [
//     "App Settings",
//     "Limits",
//     "Livestream",
//     "GIPHY",
//     "SightEngine",
//     "Admob",
//     "Onboarding",
//     "User Levels",
//     "Report Reasons",
//     "Withdrawal Gateways",
//     "DeepAR Settings",
//     "Deeplink Settings",
//     "Privacy Policy",
//     "Terms Of Uses",
//     "Admin Settings"
//   ];

//   return (
//     <aside className="sidebar-settings">
//       <div className="settingsidebar-menu">
//         {menuItems.map((item, index) => (
//           <div
//             key={index}
//             className={`settingsidebar-item ${item === "Report Reasons" ? "active" : ""}`}
//             onClick={() => navigate(`/${item.replace(/\s+/g, "")}`)}
//           >
//             {item}
//           </div>
//         ))}
//       </div>
//     </aside>
//   );
// }


export default function SettingSidebar() {
  const navigate = useNavigate();

  const menuItems = [
    { name: "App Settings", path: "/app-settings" },
    { name: "Limits", path: "/limits" },
    { name: "Livestream", path: "/livesettings" },
    { name: "GIPHY", path: "/giphy" },
    // { name: "SightEngine", path: "/sightengine" },
    { name: "Admob", path: "/admob" },
    // { name: "Onboarding", path: "/onboarding" },
    { name: "User Levels", path: "/user-levels" },
    { name: "Report Reasons", path: "/ReportReasons" },
    { name: "Withdrawal Gateways", path: "/Adminwithdraw" },
    // { name: "DeepAR Settings", path: "/deepar-settings" },
    // { name: "Deeplink Settings", path: "/deeplink-settings" },
    { name: "Privacy Policy", path: "/privacy-policy" },
    { name: "Terms Of Uses", path: "/terms" },
    { name: "Admin Settings", path: "/admin-settings" },
    { name: "Currencies", path: "/currencygrid"},
    { name: "Currency Settings", path: "/currencysettings"},
    {name: "BadwordPage" , path:"/badwordsfilters"},
    {name: 'DeepArfilters' , path:'/deeparsettings'}
  ];

  return (
    <aside className="sidebar-settings">
      <div className="settingsidebar-menu">
        
        {menuItems.map((item) => (

          <NavLink
            key={item.path}
            to={item.path}

            className={({ isActive }) =>
              `settingsidebar-item ${
                isActive ? "active" : ""
              }`
            }
          >
            {item.name}
          </NavLink>

        ))}
      </div>
    </aside>
  );
}
